export const LOCALES = {
  ENGLISH: "en",
  CATALAN: "ca",
  SPANISH: "es",
  FRENCH: "fr",
  JAPANESE: "ja",
  ITALIAN: "it",
};
